<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :menuId="menu_id"
                         :searchData="searchData"
                         @search="search"
                         @doBtn="doBtn">
                </toolBar>
                <tableGrid ref="tableGrid"
                           adaptiveHeight="110"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>

        <editDialog v-if="showEditDialog"
                    :formData="formData"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog"
                    @submitForm="submitForm">
        </editDialog>

    </div>
</template>

<script>
    import toolBar from '@/components/tools/toolBar'
    import tableGrid from '@/components/tools/table'
    import editDialog from "@/components/page/sale/commissionrate/editDialog";

    export default {
        name: "salecostprice",
        props: ['menuData'],
        components: {tableGrid, editDialog, toolBar},
        data() {
            return {
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                },

                width: "350px",

                showEditDialog: false,
                dialogLoading: false,

                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                headList: [
                    {column_name: "_px", column_comment: "序号", column_width: "70"},
                    {column_name: "salesMan", column_comment: "业务员",column_width: "150"},
                    {column_name: "minTotal", column_comment: "最小金额",column_width: "150"},
                    {column_name: "maxTotal", column_comment: "最大金额",column_width: "150"},
                    {column_name: "commissionRate", column_comment: "提成比例",column_width: "150"}
                ],
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                showImportDialog: false,
            }
        },
        mounted() {
            this.getListData();
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/commissionrate/list",
                    param: {
                        ...this.searchData.formData,
                        pageSize: this.pageInfo.pagesize,
                        currentPage: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.varList;
                    this.pageInfo.total = data.data.page.totalResult;
                }
                this.loading = false;
                this.$refs.tableGrid.clearSelList();
            },

            closeDialog() {
                this.showImportDialog = false;
                this.showEditDialog = false;
            },
            async submitForm(form) {
                this.formData = form;
                this.dialogLoading = true;
                let param = {
                    ...this.formData,
                }
                const data = await this.$sqlOpt.save.save(param, "/commissionrate/save");
                if (data.infoCode === '0') {
                    this.$refs.tableGrid.clearSelList();
                    this.$message.success("保存成功");
                    this.closeDialog();
                    await this.getListData();
                }
                this.dialogLoading = false;
            },
            toPage() {
                this.getListData();
            },
            search() {
                this.pageInfo.page = 1;
                this.getListData();
            },
            async doBtn(type) {
                let selList = this.$refs.tableGrid.getSelList();
                if (type === "add") {
                    this.formData = {}
                    this.showEditDialog = true;
                }
                if (type === "edit" || type === "delete" ) {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }
                    if (type === "edit") {
                        this.showEditDialog = true;
                    }
                    if (type === "delete" ) {
                        let param = {
                            url: "/commissionrate/delete",
                            param: {
                                commRateId: this.formData.commRateId,
                            }
                        }
                        this.$sqlOpt.del.del(param, this, this.refresh);
                    }
                }
            },
            refresh() {
                this.getListData();
            },
            tableOpt(type, data) {
                if (type === "icon") {
                    this.formData = data;
                    this.showIconDialog = true;
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }

        .Xdriver {
            position: relative;
            margin: 0 0;
            height: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }

        .Ydriver {
            position: relative;
            margin: 0 10px;
            width: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }
    }
</style>
